"use strict";

exports.__esModule = true;
exports.DeviceScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _DeviceScreenToolbar = require("../DeviceScreenToolbar");
var _API = require("../../API");
var _DeviceCollection = require("../DeviceCollection");
var _dec, _class, _DeviceScreen;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * The wrapping screen which provides the collection to the child component and search toolbar
 */
var DeviceScreen = exports.DeviceScreen = (_dec = _DeviceCollection.DeviceCollectionContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (_DeviceScreen = /*#__PURE__*/function (_Component) {
  function DeviceScreen() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      searchTerm: "",
      filterOnEnabled: true
    };
    return _this;
  }
  _inheritsLoose(DeviceScreen, _Component);
  var _proto = DeviceScreen.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      translator = _this$props.translator,
      deviceCollection = _this$props.deviceCollection;
    var translate = translator.translate;
    var _this$state = this.state,
      searchTerm = _this$state.searchTerm,
      filterOnEnabled = _this$state.filterOnEnabled;
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("DeviceScreen.title", "Devices")
    }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: translate("DeviceScreen.navbar.title", "Devices"),
      subTitle: translate("DeviceScreen.navbar.subTitle", "Administration")
    }), /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
      collection: deviceCollection,
      term: searchTerm,
      filterPredicate: function filterPredicate(item) {
        return item.enabled === filterOnEnabled;
      }
    }, function (_ref) {
      var data = _ref.data,
        error = _ref.error;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error
        });
      }
      if (!data) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_DeviceScreenToolbar.DeviceScreenToolbar, {
        enabledFilterOn: filterOnEnabled,
        onChangeEnabledToggle: function onChangeEnabledToggle(isEnabled) {
          return _this2.setState({
            filterOnEnabled: isEnabled
          });
        },
        searchTerm: searchTerm,
        count: data.length,
        onChange: function onChange(searchTerm) {
          return _this2.setState({
            searchTerm: searchTerm
          });
        },
        devices: data
      }), _this2.props.children({
        devices: data
      })));
    }));
  };
  return DeviceScreen;
}(_react.Component), _DeviceScreen.defaultProps = {
  deviceCollection: undefined,
  translator: undefined
}, _DeviceScreen)) || _class) || _class);